import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { EisRuleListItem } from './_types';
import { useEisRule } from './_data_sources/useEisRule';

interface EisRuleDetailsContextValue {
  rule: EisRuleListItem | null;
  isLoading: boolean;
  isError: boolean;
  error: any;
}

export const EisRuleDetailsContext = createContext<EisRuleDetailsContextValue>({} as EisRuleDetailsContextValue);

export const EisRuleDetailsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { id } = useParams();

  // Fetch the rule
  const ruleQuery = useEisRule(
    Number(id),
    {},
    (error) => {
      console.error('Error fetching EIS rule:', error);
    }
  );

  const rule = ruleQuery.data ?? null;

  const value: EisRuleDetailsContextValue = useMemo(
    () => ({
      rule,
      isLoading: ruleQuery.isFetching,
      isError: ruleQuery.isError,
      error: ruleQuery.isError ? ruleQuery : null,
    }),
    [rule, ruleQuery.isFetching, ruleQuery.isError]
  );

  return <EisRuleDetailsContext.Provider value={value}>{children}</EisRuleDetailsContext.Provider>;
};

export const useEisRuleDetailsContext = () => useContext(EisRuleDetailsContext);




